export class TransactionApiConverter {
  convertTransfers = data => ({
    transactions: data.data,
    total_deposit: data.total_deposit,
    total_withdrawal: data.total_withdrawal,
  });
}
